import { FC } from "react";
import { useNavigate } from "react-router-dom";
import ContentCard from "../../../../core/components/organism/ContentCard";
import { ExerciseContent } from "../../../../core/components/organism/ContentCard/components/exerciseContent";
import { LessonContent } from "../../../../core/components/organism/ContentCard/components/lessonContent";
import { MaterialContent } from "../../../../core/components/organism/ContentCard/components/materialContent";
import { PodcastContent } from "../../../../core/components/organism/ContentCard/components/podcastContent";
import { Colors } from "../../../../core/models/disciplines";
import { categoryIcon } from "../../../Favorites/utils/card";
import { ISearchResult } from "../../models";
import { searchStore } from "../../stores/searchStore";
import { categoryURL, convertType } from "../../utils";
import { EmptySearch } from "../EmptySearch";
import { RenderSearchLoading } from "../Loading";

interface IRenderSearchContentProps {
  callback: () => void;
  loading: boolean;
}

export const RenderSearchContent: FC<IRenderSearchContentProps> = ({ callback, loading }) => {
  const navigate = useNavigate();

  const { searchResult } = searchStore();

  const renderCardContent = (it: ISearchResult) => {
    if (it.type === 'podcast') {
      return <PodcastContent time={it.duration || '--:--'} />;
    }

    if (it.type === 'workbook' || it.type === 'mindmap') {
      return <MaterialContent type={it.type || ''} />;
    }

    if (it.type === 'exercise') {
      return <ExerciseContent text={it.statement || ''} />;
    }

    if (it.type === 'lesson') {
      return (
        <LessonContent
          time={it.duration || '--:--'}
          teacher={it.teacher || null}
        />
      );
    }
  };

  if (loading) {
    return <RenderSearchLoading />;
  }

  if(searchResult.length === 0) {
    return <EmptySearch />;
  }

  return (
    <div className='flex flex-col gap-lg'>
      {searchResult.map((it, i) => {
        const url = categoryURL(it);

        return (
          <ContentCard
            key={i}
            color={(it.discipline?.slug as Colors) || ('anatomia-superior' as Colors)}
            content={convertType(it.type)}
            title={it.type === 'exercise' ? undefined : it.title}
            favorite={it.favorite}
            done={it.type === 'exercise' ? it.seen : it.done}
            icon={categoryIcon(it.type)}
            iconColor='text-brand-color-secondary-pure'
            action={() => navigate(url)}
            id={it.id}
            discipline={it.discipline?.title}
            disciplineSlug={it.discipline?.slug}
            hasCallback={true}
            callback={() => callback()}
          >
            {renderCardContent(it)}
          </ContentCard>
        );
      })}
    </div>
  );
};